import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeIntegerBaseComponent } from './e5core-ui-work-field-type-integer-base';

@Component({
  selector: 'e5core-ui-work-field-type-integer-box',
  templateUrl: './e5core-ui-work-field-type-integer-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-integer-box.component.css']
})
export class E5coreUiWorkFieldTypeIntegerBoxComponent extends E5coreUiWorkFieldTypeIntegerBaseComponent {
}
